import { render, staticRenderFns } from "./FiltersExternals.vue?vue&type=template&id=bbc34668&scoped=true&"
import script from "./FiltersExternals.vue?vue&type=script&lang=js&"
export * from "./FiltersExternals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc34668",
  null
  
)

export default component.exports